export default __webpack_public_path__ + "static/media/contributorsFilled.8dbfc6ac.svg";